module.exports = __webpack_public_path__ + "img/卓翔集团公众号二维码.9cfeb0d7.png";